function helperGetDateMonth (date) {
  return date.getMonth()
}

module.exports = helperGetDateMonth



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetDateMonth.js
// module id = 77
// module chunks = 98